var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrap api-content"},[_c('ul',_vm._l((_vm.documentList),function(item,index){return _c('li',{key:index},[_c('a',{attrs:{"href":item.name}},[_vm._v(" "+_vm._s(item.name)+" ")]),_c('a',{staticClass:"btn-a",attrs:{"href":item.path,"download":item.name,"target":"_blank"}},[_vm._v(" 点击下载 ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }